import { put, takeEvery } from 'redux-saga/effects';
import { AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_FAILURE, 
    AIRLINE_REQUEST_AFTER_REJECTION_FAILURE, 
    CONFIRM_OFFER_FLIGHT_REQUEST_FAILURE 
} from "./types";
import { 
    clearAirlineRequestAfterRejection,
    clearConfirmOfferFlightRequest,
    clearFinalRejectionOfFlightRequest
} from "./actions";

function* getInterServerError(action: any) {
    if (action.error && action.error === "Internal Server Error") {
        if (action.type === AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_FAILURE) {
            yield put(clearFinalRejectionOfFlightRequest());
        }
        if (action.type === AIRLINE_REQUEST_AFTER_REJECTION_FAILURE) {
            yield put(clearAirlineRequestAfterRejection());
        }
        if (action.type === CONFIRM_OFFER_FLIGHT_REQUEST_FAILURE) {
            yield put(clearConfirmOfferFlightRequest());
        }
    }
}

export default function* flightRequestOfferSaga() {
    yield takeEvery([
        AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_FAILURE, 
        AIRLINE_REQUEST_AFTER_REJECTION_FAILURE, 
        CONFIRM_OFFER_FLIGHT_REQUEST_FAILURE
    ], getInterServerError);
}